import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Home from "../src/views/Home/Home";
import About from "../src/views/About/About";
import Products from './views/Products/Products';
import Service from './views/Services/Service';
import Contact from './views/Contact/Contact';
import Terms from "./views/TermsConditions/TermsCondition";
import NavigationBar from './components/NavigationBar/NavigationBar';
import Footer from './components/Footer/Footer';
import RegisterUser from './views/Registration/RegisterUser';
import RegisterCompany from './views/Registration/RegisterCompany';
import CertificateVerification from './views/CertificateVerify/CertificateVerify';
import Login from './views/Registration/Login';
import HandleToken from './views/Registration/HandleToken';
import NotFound from './views/NotFound/NotFound';


import RegisterChoice  from './views/Registration/RegisterChoice';
import AcountType from './views/Registration/AcountType';

/* Cross-page anchor links (e.g. /home#work) land before the lazy section
   has mounted, so the browser's native hash scroll finds nothing. Retry a few
   times, then give up. */
function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return undefined;
    }
    let tries = 0;
    const id = setInterval(() => {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        clearInterval(id);
      } else if (++tries > 20) {
        clearInterval(id);
      }
    }, 100);
    return () => clearInterval(id);
  }, [pathname, hash]);

  return null;
}

export default function Router() {
  return (
    <div>
        <NavigationBar/>
        <ScrollToHash/>
        <Routes>
            <Route path="/" element={<Navigate to="/home" replace />} />
            <Route path="/home" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Products />} />
            <Route path="/service" element={<Service />} />
            <Route path="/contactus" element={<Contact />} />
            <Route path="/terms" element={<Terms/>}/>
            <Route path="/login" element={<Login/>}/>
            <Route path='/registeruser' element={<RegisterUser/>}/>
            <Route path='/registercompany' element={<RegisterCompany/>}/>
            <Route path='/RegisterChoice' element={<RegisterChoice/>}/>
            <Route path='/acounttype' element={<AcountType/>}/>
            <Route path='/certificate-verification' element={<CertificateVerification/>}/>
            <Route path="/handle-token" element={<HandleToken />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer/>
   </div>
  )
}
